import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AlertModule } from '@shared/alert/alert.module';
import { LayoutModule } from '@shared/layout/layout.module';
import { VersionModalModule } from '@shared/modals/version-modal/version-modal.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { HomeComponent } from './home/home.component';
import { SeletorProjetosModule } from './seletor-projetos/seletor-projetos.module';
import { HomeSidebarComponent } from './sidebar/home-sidebar.component';

@NgModule({
    declarations: [HomeSidebarComponent, HomeComponent],
    exports: [HomeSidebarComponent],
    imports: [
        CommonModule,
        VersionModalModule,
        RouterModule,
        NgxSpinnerModule,
        NgbModule,
        MatButtonModule,
        LayoutModule,
        AlertModule,
        SeletorProjetosModule,
    ],
})
export class HomeModule {}
